export enum ProductStatus {
  PAUSE = "PAUSE",
  PROCESS = "PROCESS",
  DELETE = "DELETE",
}

export enum ProductCollection {
  SKINCARE = "SKINCARE",
  HAIRCARE = "HAIRCARE",
  MAKEUP = "MAKEUP",
  FRAGRANCE = "FRAGRANCE",
  PERSONALCARE = "PERSONALCARE",
}
